export default function HeartbeatLine({ className = "", color = "#E94B2C", thickness = 2.4, height = 80 }) {
  return (
    <svg
      viewBox="0 0 1200 100"
      preserveAspectRatio="none"
      className={className}
      style={{ height, width: "100%" }}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="hbGlow" x1="0" x2="1">
          <stop offset="0" stopColor={color} stopOpacity="0" />
          <stop offset="0.5" stopColor={color} stopOpacity="0.9" />
          <stop offset="1" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <path
        d="M0 50 L120 50 L150 50 L165 50 L180 20 L200 80 L220 30 L240 70 L260 50 L420 50 L440 50 L455 50 L470 25 L490 75 L510 35 L530 65 L550 50 L780 50 L800 50 L815 50 L830 18 L850 82 L870 28 L890 72 L910 50 L1200 50"
        stroke={color}
        strokeWidth={thickness}
        fill="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeDasharray="2400"
        style={{ animation: "pulseLine 6s linear infinite" }}
      />
      <path
        d="M0 50 L120 50 L150 50 L165 50 L180 20 L200 80 L220 30 L240 70 L260 50 L420 50 L440 50 L455 50 L470 25 L490 75 L510 35 L530 65 L550 50 L780 50 L800 50 L815 50 L830 18 L850 82 L870 28 L890 72 L910 50 L1200 50"
        stroke="url(#hbGlow)"
        strokeWidth={thickness * 3}
        fill="none"
        opacity="0.4"
        strokeLinecap="round"
      />
    </svg>
  );
}
